<app-navbar></app-navbar>
<section class="assessment-page py-4 py-xl-5 main-section-body-content">
    <div class="container">
        <div class="page-header mb-4">
            <h2>Assessment Catalog</h2>
            <!-- <p>Choose an assessment to start or edit assessment definitions as an administrator.</p> -->
        </div>
        <mat-card *ngIf="isMember && assessmentAttemptBlocked" class="assessment-complete-banner mb-4">
            <mat-card-content class="text-center">
                <mat-icon aria-hidden="true">check_circle</mat-icon>
                <h3>Thank you for completing the assessment!</h3>
            </mat-card-content>
        </mat-card>
        <!-- Welcome Message -->
        <mat-card *ngIf="isMember && !assessmentAttemptBlocked && !loadingAttemptAccess" class="konvac-info-banner mb-4">
            <mat-card-content class="d-flex align-items-center">
                <h5 class="mb-0">
                    Welcome to Konvac! Choose an assessment below to begin.
                </h5>
            </mat-card-content>
        </mat-card>
        <mat-card id="assessment-device-requirement" *ngIf="assessmentScreenUnsupported && (!isMember || !assessmentAttemptBlocked)" class="device-requirement-banner mb-4">
            <mat-card-content>
                <mat-icon aria-hidden="true">desktop_windows</mat-icon>
                <div>
                    <h5>Laptop or desktop required</h5>
                    <p>The assessment cannot be started on a phone or tablet. Please use a desktop or laptop to continue.</p>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="isMember && !assessmentAttemptBlocked && !loadingAttemptAccess && !resumeUrl && !resumePromptDismissed" class="resume-reminder mb-4">
            <mat-card-content>
                <div class="resume-reminder-copy">
                    <mat-icon>description</mat-icon>
                    <div>
                        <h5>Add your resume to complete your profile</h5>
                        <p>You can skip this for now, but a resume is required before you start an assessment.</p>
                    </div>
                </div>
                <div class="resume-reminder-actions">
                    <button type="button" class="reminder-skip" (click)="dismissResumePrompt()">Skip for now</button>
                    <a class="app-btn app-btn-primary" routerLink="/profile">Update profile</a>
                </div>
            </mat-card-content>
        </mat-card>
        <div *ngIf="loadingAttemptAccess" class="assessment-access-loading">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
        <div *ngIf="!isMember || (!assessmentAttemptBlocked && !loadingAttemptAccess)" class="create-new-assessment-grid">
            <div *ngIf="isAdmin"  class="mb-3">
                <mat-card class="h-100 d-flex align-items-center justify-content-center text-center cursor-pointer transition-all-03 create-new-assessment-box">
                    <mat-card-content>
                       <a routerLink="/assessment-builder"><h4 class="mid-title mb-0">+ Create New Assessment</h4></a>
                    </mat-card-content>
                </mat-card>
            </div>
            <div *ngFor="let assessment  of assessments" class="mb-3">
                <mat-card class="assessment-card">
                    <mat-card-content>
                        <div class="row create-new-assessment-text-wrap">
                            <div class="col-md-12 d-flex align-items-center gap-2 mb-2">
                               <h5 class="mb-0">Assessment Name:</h5>&nbsp; <h6 class="mb-0">{{assessment.assessmentTitle}}</h6>
                            </div>
                            <!-- <div class="col-md-12 d-flex align-items-center gap-2 mb-2">
                                <h5 class="mb-0">Age Group:</h5>&nbsp; <h6 class="mb-0">{{assessment.ageGroup}}</h6>
                            </div> -->
                            <div class="col-md-12 d-flex align-items-center gap-2 mb-2">
                                <h5 class="mb-0">Sections:</h5>&nbsp; <h6 class="mb-0">{{assessment.sections}}</h6>
                            </div>
                            <div class="col-md-12 d-flex align-items-center gap-2 mb-2">
                                <h5 class="mb-0">Time:</h5>&nbsp; <h6 class="mb-0">{{assessment.assessmentTimeline}}</h6>&nbsp; Min(s)
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-divider ></mat-divider>
                    <mat-card-footer>
                        <div class="row py-3 mx-0 action-row">
                            <div *ngIf="isAdmin"  class="col-md-6 text-center">
                                <button class="app-btn app-btn-primary w-100 mb-2 mb-md-0" color="accent" (click)="editAssessmentRoute(assessment.assessmentId)">Edit</button>
                            </div>
                            <div class="col-md-6 text-center">
                                <button
                                    class="app-btn app-btn-success w-100"
                                    (click)="startAssessmentRoute(assessment.assessmentId)"
                                    [disabled]="assessmentScreenUnsupported"
                                    [attr.aria-describedby]="assessmentScreenUnsupported ? 'assessment-device-requirement' : null">
                                    {{ assessmentScreenUnsupported ? 'Use a laptop or desktop' : 'Attempt' }}
                                </button>
                            </div>
                        </div>
                    </mat-card-footer>
                </mat-card>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
